import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		inventory: []
	},

	actions: {
		fetchAll({ commit }, { materialId, date, withDetails, ownerIds } = {}) {
			const urlSearchParams = new URLSearchParams()
			const params = { materialId, date, withDetails }

			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach((ownerId) => {
					urlSearchParams.append('ownerIds', ownerId)
				})
			}
			return axios.get('/itemTransaction/inventory', {
				params: urlSearchParams
			}).then(data => {
				const storeDate = data.map((c, i) => ({ id: String(i + 1), ...c }))
				commit(types.STORE_INVENTORY, storeDate);
				return storeDate;
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		}
	},

	mutations: {
		[types.STORE_INVENTORY](state, inventory) {
			state.inventory = inventory;
		},
		[types.RESET](state) {
			state.inventory = [];
		},
	}
}